import Vue from 'vue'
import Vuex from 'vuex'
import FastClick from 'fastclick'
import HttpRequest from './plugins/http'
import Wechat from './plugins/wechat'
import Authenticate from './plugins/auth'
import router from './router/index'
import App from './App'
import dateFormat from 'vux/src/tools/date/format.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Marquee from 'vux/src/components/marquee/marquee.vue'
import MarqueeItem from 'vux/src/components/marquee/marquee-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Sticky from 'vux/src/components/sticky/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Card from 'vux/src/components/card/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'


Vue.use(Vuex)
Vue.use(LoadingPlugin)
Vue.use(ToastPlugin)
Vue.use(HttpRequest)
Vue.use(Wechat)
Vue.use(Authenticate)

Vue.component('x-header', XHeader)
Vue.component('sticky', Sticky)
Vue.component('tab', Tab)
Vue.component('tab-item', TabItem)
Vue.component('card', Card)
Vue.component('load-more', LoadMore)
Vue.component('swiper', Swiper)
Vue.component('swiper-item', SwiperItem)
Vue.component('marquee', Marquee)
Vue.component('marquee-item', MarqueeItem)
Vue.component('previewer', Previewer)
Vue.component('box', Box)
Vue.component('x-button', XButton)
Vue.component('x-input', XInput)
Vue.component('flexbox', Flexbox)
Vue.component('flexbox-item', FlexboxItem)
Vue.component('x-dialog', XDialog)
Vue.component('group', Group)
Vue.component('cell', Cell)

Vue.prototype.$dateFormat = dateFormat

Vue.prototype.$week = (date) => {
if (!date) date = new Date()
let week = date.getDay()
if (week === 0) return '星期日'
else if (week === 1) return '星期一'
else if (week === 2) return '星期二'
else if (week === 3) return '星期三'
else if (week === 4) return '星期四'
else if (week === 5) return '星期五'
else if (week === 6) return '星期六'
else return ''
}

Vue.filter('formatDate', function (value) {
if (value) {
return dateFormat(new Date(Date.parse(value.replace(/-/g, '/'))), 'YYYY年M月D日')
} else {
return value
}
})

Vue.filter('formatTime', function (value) {
if (value) {
let time = new Date(value)
let now = new Date()
let timeDiff = now - time

if (timeDiff < 0) {
if (now.getFullYear() !== time.getFullYear()) {
return dateFormat(time, 'YYYY年M月D日 HH:mm')
} else if (now.getDate() !== time.getDate()) {
return dateFormat(time, 'M月D日 HH:mm')
} else {
return dateFormat(time, 'HH:mm')
}
} else if (timeDiff < 1000 * 60 * 3) {
return '刚刚'
} else if (timeDiff < 1000 * 60 * 59) {
return Math.round(timeDiff / 1000 / 60) + '分钟前'
} else if (timeDiff < 1000 * 60 * 60 * 24) {
return dateFormat(time, 'HH:mm')
} else if (timeDiff < 1000 * 60 * 60 * 24 * 180 ||
now.getFullYear() === time.getFullYear()) {
return dateFormat(time, 'M月D日 HH:mm')
} else {
return dateFormat(time, 'YYYY年M月D日 HH:mm')
}
} else {
return value
}
})

let store = new Vuex.Store({})

store.registerModule('sx', {
state: {
user: Vue.getUser(),
isLoading: false,
scrollTop: {},
scrollBottom: false
},
mutations: {
getUser (state) {
state.user = Vue.getUser()
},
setUser (state, payload) {
Vue.setUser(payload.user)
state.user = payload.user
},
updateLoadingStatus (state, payload) {
state.isLoading = payload.isLoading
},
updateScrollPosition (state, payload) {
Vue.set(state.scrollTop, payload.path, payload.top)
state.scrollBottom = payload.isBottom
}
},
actions: {
setUser ({commit}, user) {
commit({type: 'setUser', user: user})
},
getUser ({commit}) {
commit({type: 'getUser'})
},
updateScrollPosition ({commit}, position) {
commit({type: 'updateScrollPosition', path: position.path, top: position.top, isBottom: position.isBottom})
}
}
})

let _hmt = window._hmt || []

router.beforeEach(function (to, from, next) {
store.commit('updateLoadingStatus', {isLoading: true})
if (to.path) {
_hmt.push(['_trackPageview', '/#' + to.path])
}
if (Vue.isWechat() && to.query.code && to.query.state &&
store.state.sx.user == null) {
let query = to.query
Vue.post('cst/getUserInfo', {
code: query.code
}, (res) => {
if (res.code === 200) {
if (res.data && res.data.userId) {
store.commit('setUser', {user: res.data})
}
}
next({name: to.name, params: to.params, replace: true})
})
} else if (window.history.length <= 1 && !to.query.index && !from.query.index) {
let query = to.query
Vue.set(query, 'index', 'true')
next({name: to.name, params: to.params, query: query, replace: true})
} else if (Vue.isWechat() && store.state.sx.user == null) {
let url = encodeURIComponent(window.location.protocol + '//' + window.location.host + '/shixing' + to.fullPath)
window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf2e9e632dec9e36c&redirect_uri=' +
url + '&response_type=code&scope=snsapi_base&state=123#wechat_redirect'
next(false)
} else {
next()
}
})

router.afterEach(function (to) {
store.commit('updateLoadingStatus', {isLoading: false})
})

FastClick.attach(document.body)

Vue.config.productionTip = false

new Vue({
store,
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js